import Time from "./Time";
import Input from "./Input";
Input.displayName = "Input";
Input.Time = Time;
Input.Time.displayName = `${Input.displayName}.Time`;
export default Input;
//# sourceMappingURL=index.js.map